import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { Accnt } from '../accnt/Accnt';
import { Incident } from '../incident/Incident';
import { LoadBal } from '../load-bal/LoadBal';
import { Mngr } from '../mngr/Mngr';
import { Monitor } from '../monitor/Monitor';
import { NasVol } from '../nas-vol/NasVol';
import { Nks } from '../nks/Nks';
import { ServiceHist } from '../service-hist/ServiceHist';
import { Vm } from '../vm/Vm';

/**
 * # SimpleReport
 *
 * SimpleReport을 설명하세요.
 */
export const SimpleReport = types
  .model('SimpleReport')
  // --------------------------------------------------------------------------
  .props({
    // reportSid: null,
    // reportNm: null,
    year: types.maybeNull(types.string),
    month: types.maybeNull(types.string),
    // writeCmpny: null,
    // writerNm: null,
    // cnfirmNm: null,

    // infraImage: null,

    // appendix: null,
    // conclusion: null,
    // etc: null,

    accntInfos: types.maybeNull(types.optional(types.array(Accnt), [])),
    incidents: types.maybeNull(types.optional(types.array(Incident), [])),
    loadBals: types.maybeNull(types.optional(types.array(LoadBal), [])),
    mngrInfos: types.maybeNull(types.optional(types.array(Mngr), [])),
    // mngrs: types.maybeNull(types.optional(types.array(Mngr), [])),
    monitorings: types.maybeNull(types.optional(types.array(Monitor), [])),
    nasVols: types.maybeNull(types.optional(types.array(NasVol), [])),
    nkss: types.maybeNull(types.optional(types.array(Nks), [])),
    // servhists: types.maybeNull(types.optional(types.array(ServiceHist), [])),
    serviceHists: types.maybeNull(types.optional(types.array(ServiceHist), [])),
    vmhists: types.maybeNull(types.optional(types.array(Vm), [])),

    // insertDt: null,
    // updateDt: null,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model simpleReport --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ISimpleReport;
      (Object.keys(newProps) as TSimpleReportKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TSimpleReport = Instance<typeof SimpleReport>;
type TSimpleReportSnapshot = SnapshotOut<typeof SimpleReport>;

export interface ISimpleReport extends TSimpleReport {}
export type TSimpleReportKeys = keyof TSimpleReportSnapshot & string;
export interface ISimpleReportSnapshot extends TSimpleReportSnapshot {}
export const createSimpleReport = () => types.optional(SimpleReport, {} as TSimpleReport);
